import { __assign } from '../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { createContext, useState, useCallback, useEffect, useContext } from 'react';
import BusinessUnitChangeModal from '../Navbar/MyAccount/BusinessunitChangeModal/index.js';
import Cookie from '../shared/utils/cookie.js';
import { useOrganizationContext } from './OrganizationProvider.js';

var BusinessUnitChangeModalContext = createContext(null);
var BusinessUnitChangeModalProvider = function (_a) {
    var children = _a.children;
    var context = useState(false);
    var _b = useOrganizationContext(), organization = _b.organization, organizations = _b.organizations;
    var _c = useState(), businessUnit = _c[0], setBusinessUnit = _c[1];
    var isShowModal = context[0], setIsShowModal = context[1];
    var handleShowModal = useCallback(function () {
        if (document.hidden) {
            return;
        }
        var currentBusinessUnit = Number(Cookie.getCookie("business_unit_id"));
        var isChanged = !!currentBusinessUnit &&
            !!organization.buId &&
            organization.buId !== currentBusinessUnit;
        if (isChanged) {
            var businessUnit_1 = organizations === null || organizations === void 0 ? void 0 : organizations.find(function (organization) { return organization.buId === currentBusinessUnit; });
            if (businessUnit_1) {
                setIsShowModal(true);
                setBusinessUnit(businessUnit_1);
                return;
            }
            setBusinessUnit(undefined);
            return;
        }
        setIsShowModal(false);
    }, [organization.buId, organizations, setIsShowModal]);
    useEffect(function () {
        var intervalId = window.setInterval(handleShowModal, 1000);
        return function () { return window.clearInterval(intervalId); };
    });
    return (jsxs(BusinessUnitChangeModalContext.Provider, __assign({ value: context }, { children: [children, jsx(BusinessUnitChangeModal, { isActive: isShowModal, businessUnit: businessUnit }, void 0)] }), void 0));
};
var useBusinessUnitChangeModalContext = function () {
    var context = useContext(BusinessUnitChangeModalContext);
    if (!context) {
        throw new Error("useBusinessUnitChangeModalContext must be used within a BusinessUnitChangeModalProvider");
    }
    return context;
};

export { BusinessUnitChangeModalProvider as default, useBusinessUnitChangeModalContext };
